module.exports = __webpack_public_path__ + "img/C2_HQ.569c54a3.jpg";